import Cookies from "js-cookie";

const COOKIES_STORAGE_KEY = "tonic3_cookiesSettings";
const ANALYTICAL_PERFORMANCE_COOKIES = [
  {
    domain: ".google.com",
    names: ["_ga", "_gat", "_gid"],
  },
];
const MARKETING_SOCIAL_MEDIA_COOKIES = [
  {
    domain: ".google.com",
    names: [
      "NID",
      "APISID",
      "CONSENT",
      "HSID",
      "SAPISID",
      "SID",
      "SSID",
      "1P_JAR",
    ],
  },
  {
    domain: ".doubleclick.net",
    names: ["IDE"],
  },
  {
    domain: ".linkedin.com",
    names: ["UserMatchHistory", "bcookie", "lidc"],
  },
];

export const CookieSettingsEmum = {
  ESSENTIAL_COOKIES: "ESSENTIAL_COOKIES",
  ANALYTICAL_PERFORMANCE_COOKIES: "ANALYTICAL_PERFORMANCE_COOKIES",
  MARKETING_SOCIAL_MEDIA_COOKIES: "MARKETING_SOCIAL_MEDIA_COOKIES",
};

export const getCookieSettings = () => {
  const settings = localStorage.getItem(COOKIES_STORAGE_KEY);
  if (settings) return JSON.parse(settings);
  return null;
};

export const updateCookieSettings = settings =>
  localStorage.setItem(COOKIES_STORAGE_KEY, JSON.stringify(settings));

export const acceptAllCookiesSettings = () => {
  const settings = {};
  Object.values(CookieSettingsEmum).forEach(setting => {
    settings[setting] = true;
  });

  updateCookieSettings(settings);
};

export const rejectNonEssentialCookiesSettings = () => {
  const settings = {};
  Object.values(CookieSettingsEmum).forEach(setting => {
    settings[setting] = setting === CookieSettingsEmum.ESSENTIAL_COOKIES;
  });

  updateCookieSettings(settings);
};

export const manageCookies = settings => {
  if (!settings.ESSENTIAL_COOKIES) {
    localStorage.removeItem("theme-ui-color-mode");
    localStorage.removeItem("_grecaptcha");
  }

  if (!settings.ANALYTICAL_PERFORMANCE_COOKIES) {
    removeCookies(ANALYTICAL_PERFORMANCE_COOKIES);
  }

  if (!settings.MARKETING_SOCIAL_MEDIA_COOKIES) {
    removeCookies(MARKETING_SOCIAL_MEDIA_COOKIES);
  }
};

const removeCookies = cookiesList => {
  for (const { domain, names } of cookiesList) {
    names.forEach(name => Cookies.remove(name, { path: "/", domain }));
  }
};
